import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderHero from "../HeaderHero";
import { useParams, useNavigate } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import { FaArrowLeft } from "react-icons/fa6";
import Swal from "sweetalert2";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useCart } from "../Context/CartContext";

function ProductDetails() {
  const { productId } = useParams();
  //const [quantity, setQuantity] = useState(1);
  const [data, setData] = useState([]);
  const [ProductId, setProductId] = useState("");
  const [ProductName, setProductName] = useState("");
  const [CurrentAmount, setCurrentAmount] = useState("");
  const [PreviousAmount, setPreviousAmount] = useState("");
  const [Description, setDescription] = useState("");
  const [BannerImage, setBannerImage] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    GetProductList();
  }, [productId]);

  function GetProductList() {
    fetch(
      `https://api.domehelp.com/ProductInformation/GetProductDetailAllByID?ID=${productId}`,
      {
        method: "GET",
      },
    )
      .then((response) => {
        if (!response.ok) {
          Swal.fire("Warning!", "getting Error.", "warning");
          return false;
        }
        return response.json();
      })
      .then((result) => {
        if (result.status === 1) {
          setData(result.data);
          setProductId(result.data[0].jobId);
          setProductName(result.data[0].jobName);
          setCurrentAmount(result.data[0].currentAmount);
          setPreviousAmount(result.data[0].previousAmount);
          setDescription(result.data[0].description);
          setBannerImage(result.data[0].bannerImage || "");
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        Swal.fire("Warning!", error.toString(), "warning");
      });
  }

  const { addToCart } = useCart();

  const AddToCart = (productId) => {
    const added = addToCart(productId);

    if (added) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Product added to cart successfully!",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          popup: "cart-toast",
        },
      });
    } else {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "info",
        title: "This product is already in your cart.",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          popup: "cart-toast",
        },
      });
    }
  };

  const navigate = useNavigate();

  const BuyNow = (productId) => {
    AddToCart(productId);
    navigate("/Checkout");
  };

  return (
    <>
      <HeaderHero Name={ProductName} />
      <div className="product-details-section">
        <div className="container">
          <div className="row align-items-start gx-5">
            {/* Gallery */}

            <div className="col-lg-5">
              <div className="product-gallery">
                <Carousel interval={null} indicators data-bs-theme="dark">
                  {BannerImage ? (
                    <Carousel.Item>
                      <img
                        className="gallery-image"
                        src={`https://api.domehelp.com/ProductDoc/${BannerImage}`}
                        alt={ProductName}
                      />
                    </Carousel.Item>
                  ) : (
                    <Carousel.Item>
                      <div className="gallery-placeholder">
                        <i className="bi bi-file-earmark-excel-fill"></i>
                      </div>
                    </Carousel.Item>
                  )}

                  {data
                    .filter((x) => x.pxImageUrl)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="gallery-image"
                          src={`https://api.domehelp.com/ProductDoc/${item.pxImageUrl}`}
                          alt={ProductName}
                        />
                      </Carousel.Item>
                    ))}
                </Carousel>
              </div>
            </div>

            {/* Details */}

            <div className="col-lg-7">
              <div className="product-info">
                <span className="product-badge">Premium Database</span>

                <h1 className="product-title">{ProductName}</h1>

                <div className="price-box">
                  <span className="current-price">₹{CurrentAmount}</span>

                  {PreviousAmount > CurrentAmount && (
                    <>
                      <del className="old-price">₹{PreviousAmount}</del>

                      <span className="discount">
                        {Math.round(
                          ((PreviousAmount - CurrentAmount) / PreviousAmount) *
                            100,
                        )}
                        % OFF
                      </span>
                    </>
                  )}
                </div>

                <div className="product-features">
                  <div>
                    <i className="bi bi-file-earmark-excel-fill"></i>
                    Excel / CSV Dataset
                  </div>

                  <div>
                    <i className="bi bi-cloud-download"></i>
                    Instant Download
                  </div>

                  <div>
                    <i className="bi bi-shield-check"></i>
                    Secure Checkout
                  </div>
                </div>

                <div className="product-actions">
                  <button
                    type="button"
                    className="cart-btn-product"
                    onClick={() => AddToCart(productId)}
                  >
                    <i className="bi bi-cart-plus-fill me-2"></i>
                    Add to Cart
                  </button>

                  <Link className="buy-btn" to={`/Checkout/${productId}`}>
                    <i className="bi bi-file-earmark-arrow-down-fill me-2"></i>
                    Buy Now
                  </Link>
                </div>

                <Link className="back-link" to="/Products">
                  <FaArrowLeft className="me-2" />
                  Browse Products
                </Link>
              </div>
            </div>
          </div>

          {Description?.trim() && (
            <section className="description-section">
              <h2>Description</h2>

              <div
                className="description-content"
                dangerouslySetInnerHTML={{
                  __html: Description,
                }}
              />
            </section>
          )}
        </div>
      </div>
    </>
  );
}
export default ProductDetails;
